import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Zap } from 'lucide-react';
// --- Geo-based pricing ---
interface PriceData {
  oldPrice: string;
  newPrice: string;
  savings: string;
  ctaPrice: string;
}
const PRICES: Record<string, PriceData> = {
  MX: {
    oldPrice: 'MXN $280',
    newPrice: 'MXN $130',
    savings: 'AHORRAS MXN $150',
    ctaPrice: '$130 MXN'
  },
  CO: {
    oldPrice: 'COP $61,000',
    newPrice: 'COP $28,000',
    savings: 'AHORRAS COP $33,000',
    ctaPrice: '$28,000 COP'
  },
  AR: {
    oldPrice: 'ARS $19,999',
    newPrice: 'ARS $6,500',
    savings: 'AHORRAS ARS $13,499',
    ctaPrice: '$6,500 ARS'
  },
  CL: {
    oldPrice: 'CLP $14,600',
    newPrice: 'CLP $6,500',
    savings: 'AHORRAS CLP $8,100',
    ctaPrice: '$6,500 CLP'
  },
  PE: {
    oldPrice: 'S/ 54.99',
    newPrice: 'S/ 26.00',
    savings: 'AHORRAS S/ 28.99',
    ctaPrice: 'S/ 26.00'
  },
  DEFAULT: {
    oldPrice: 'USD $27.00',
    newPrice: 'USD $6.36',
    savings: 'AHORRAS USD $20.64',
    ctaPrice: '$6.36 USD'
  }
};
const EU_COUNTRIES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
const EU_PRICE: PriceData = {
  oldPrice: '€13.00',
  newPrice: '€6.50',
  savings: 'AHORRAS €6.50',
  ctaPrice: '€6.50'
};
function useGeoPrice() {
  const [price, setPrice] = useState<PriceData>(PRICES.DEFAULT);
  useEffect(() => {
    fetch('https://get.geojs.io/v1/ip/country.json').then(r => r.json()).then(d => {
      const c = (d.country || '').toUpperCase();
      if (EU_COUNTRIES.includes(c)) setPrice(EU_PRICE);else setPrice(PRICES[c] || PRICES.DEFAULT);
    }).catch(() => setPrice(PRICES.DEFAULT));
  }, []);
  return price;
}
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(29 * 60 + 47);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft(t => Math.max(0, t - 1)), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 bg-[var(--red-emphasis)]/15 border border-[var(--red-emphasis)]/30 rounded-lg px-3 py-2 mb-4" data-id="element-148">
      <Zap className="w-3.5 h-3.5 text-[var(--red-emphasis)] fill-current flex-shrink-0" data-id="element-149" />
      <span className="text-xs text-[var(--text-primary)]" data-id="element-150">Expira en:</span>
      <div className="flex items-center gap-1 font-mono font-bold text-[var(--red-emphasis)] text-base" data-id="element-151">
        <span className="bg-[var(--red-emphasis)]/20 px-1.5 py-0.5 rounded" data-id="element-152">
          {pad(minutes)}
        </span>
        <span className="animate-pulse" data-id="element-153">:</span>
        <span className="bg-[var(--red-emphasis)]/20 px-1.5 py-0.5 rounded" data-id="element-154">
          {pad(seconds)}
        </span>
      </div>
    </div>;
}
const bonuses = [{
  label: 'Guía Digital — 40 Días de Reconstrucción',
  value: '$27',
  image: 'https://cdn.magicpatterns.com/uploads/aiae3fzkvQYnByxGYXB5Et/COVER.png'
}, {
  label: 'Bono #1 — Oraciones de Rescate',
  value: '$12',
  image: 'https://cdn.magicpatterns.com/uploads/uhLWM1JGhFCwioEgwKr8mA/1.png'
}, {
  label: 'Bono #2 — Plan 5×5',
  value: '$12',
  image: 'https://cdn.magicpatterns.com/uploads/wiWCXRqeJFZwywy4CCeeHF/2.png'
}, {
  label: 'Bono #3 — 40 Promesas',
  value: '$12',
  image: 'https://cdn.magicpatterns.com/uploads/6msJJKZkXy3iUxeCqMGhQC/3.png'
}];
export function CTASection() {
  const price = useGeoPrice();
  const handleBuy = () => {
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Elegido en el Dolor',
        content_type: 'product',
        value: 6.36,
        currency: 'USD'
      });
    }
    window.open('https://simplementemejor.com/cart/51706800537880:1', '_blank');
  };
  return <section id="cta-section" className="py-8 md:py-10 px-4 md:px-6 bg-[var(--bg-deep)] relative overflow-hidden" data-id="element-155">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(196,164,74,0.05) 0%, transparent 70%)'
    }} data-id="element-156" />

      <div className="max-w-[520px] mx-auto relative z-10" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[var(--bg-card)] border border-[var(--accent)]/25 p-4 md:p-6 rounded-xl text-center shadow-[0_4px_40px_rgba(0,0,0,0.08)]" data-id="element-158">
          <p className="text-[var(--accent)] uppercase tracking-widest text-[10px] font-bold mb-1" data-id="element-159">
            Oferta de Lanzamiento
          </p>
          <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] mb-1" data-id="element-160">
            Empieza tu Día 1 hoy
          </h2>

          <CountdownTimer data-id="element-161" />

          {/* Value stack — clean, no expandables */}

          {/* Price */}
          <div className="flex items-baseline justify-center gap-3 mb-1" data-id="element-162">
            <span className="text-base text-[var(--text-muted)] line-through opacity-60" data-id="element-163">
              {'USD $27.00'}
            </span>
            <span className="text-4xl font-serif font-bold text-[var(--accent)]" data-id="element-164">
              {'USD $14.36'}
            </span>
          </div>
          <div className="inline-block bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#110608] px-3 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider mb-3" data-id="element-165">
            {'AHORRAS USD $12.64'}
          </div>

          {/* CTA Button */}
          <motion.button onClick={handleBuy} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(196,164,74,0)', '0 0 40px 12px rgba(196,164,74,0.3)', '0 0 0 0 rgba(196,164,74,0)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="relative w-full py-4 bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#110608] font-extrabold text-sm md:text-base rounded-lg shadow-lg overflow-hidden group cursor-pointer mb-3 whitespace-nowrap" data-id="element-166">
            <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-167" />
            <span className="relative flex items-center justify-center gap-2" data-id="element-168">
              SÍ, QUIERO EMPEZAR — $14.36 USD
            </span>
          </motion.button>

          {/* Trust badges + guarantee — merged compact */}
          <div className="flex items-center justify-center gap-3 text-[10px] text-[var(--text-muted)] mb-3 flex-wrap" data-id="element-169">
            <span className="flex items-center gap-1" data-id="element-170">
              <Lock className="w-3 h-3" data-id="element-171" /> Pago Seguro
            </span>
            <span className="opacity-30" data-id="element-172">|</span>
            <span className="flex items-center gap-1" data-id="element-173">
              <Zap className="w-3 h-3" data-id="element-174" /> Acceso inmediato a tu correo
            </span>
          </div>

          {/* Guarantee — compact */}
          <div className="border border-[var(--accent)]/15 bg-[var(--accent)]/5 rounded-lg p-3" data-id="element-175">
            <p className="text-[11px] text-[var(--text-muted)] leading-relaxed" data-id="element-176">
              <ShieldCheck className="w-3.5 h-3.5 text-[var(--accent)] inline mr-1 -mt-0.5" data-id="element-177" />
              <strong className="text-[var(--text-heading)]" data-id="element-178">
                Garantía 7 días:
              </strong>{' '}
              Si no te ayuda, pides reembolso. Sin preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}